import { orchestrator } from 'satcheljs';
import { onMonthCellClick } from '../actions/monthCellOnClickActions';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { isSameDay } from 'owa-datetime';
import { monthQuickAdd } from 'owa-quick-compose-controller';
import { updateSelectedDate } from 'owa-calendar-surface';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { getIsAgendaPaneShown } from 'owa-calendar-layout';

/**
 * Opens the quick-compose for creating a new event
 *
 */
orchestrator(onMonthCellClick, actionMessage => {
    const surfaceStore = getSurfaceStore();

    const datapoint = returnTopExecutingActionDatapoint();
    datapoint.addCustomData({ currentDateRangeType: surfaceStore.dateRangeType });

    if (!getIsAgendaPaneShown() || isSameDay(actionMessage.date, surfaceStore.selectedDate)) {
        monthQuickAdd(actionMessage.date, actionMessage.currentTarget);
    }
    updateSelectedDate(actionMessage.date, surfaceStore);
});
